<section class="faqs">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-tit1">
          {{titulo}}
        </h1>
        <neo-colapsar [elementos]="secciones['faq']['faq-faq']['elementos']" [itemInicialActivo]="faqInicialActivo">
        </neo-colapsar>
        <div class="faq-form">
          <neo-contacto-faq></neo-contacto-faq>
        </div>
      </div>
    </div>
  </div>
</section>